export default __webpack_public_path__ + "static/media/logo.728667f6.svg";